export function formatHistoryWorkTime(value: string | null | undefined): string {
    if (!value) return 'Not recorded';
    const match = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})-(\d{1,2})-(\d{1,2})(?:-(\d{1,2}))?$/);
    if (!match) return value;
    const [, day, month, year, hour, minute, second] = match;
    return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year}, ${hour.padStart(2, '0')}:${minute.padStart(2, '0')}${second ? ':' + second.padStart(2, '0') : ''}`;
}
